
export const getByCep = (cep: string): Promise<Response> => fetch(`https://viacep.com.br/ws/${cep}/json/`);